import React from 'react';
import { Phone, Mail, MapPin, UserCheck } from 'lucide-react';
import { GRUPO } from './c360Shared';

const Stat = ({ label, value, testId }) => (
  <div className="px-4 py-2 rounded-xl bg-white/10" data-testid={testId}>
    <div className="text-2xl font-bold font-[Outfit]">{value}</div>
    <div className="text-[11px] uppercase tracking-wider text-white/70">{label}</div>
  </div>
);

export const ClientHeader = ({ cliente, resumo }) => (
  <div className="rounded-2xl bg-[#2D3E6F] text-white p-6 flex flex-col lg:flex-row lg:items-end gap-6 justify-between" data-testid="c360-header">
    <div className="space-y-3 min-w-0">
      <div className="text-xs uppercase tracking-[0.2em] text-[#4DD4E8]">Página do Cliente</div>
      <h1 className="text-3xl sm:text-4xl font-bold font-[Outfit] break-words" data-testid="c360-client-name">{cliente.nome || 'Sem nome'}</h1>
      <div className="flex flex-wrap gap-x-5 gap-y-1 text-sm text-white/85">
        <span className="font-mono" data-testid="c360-client-nif">NIF {cliente.nif || '—'}</span>
        {cliente.telefones?.map((t) => (
          <a key={t} href={`tel:${t}`} className="inline-flex items-center gap-1 hover:text-[#4DD4E8]"><Phone className="w-3.5 h-3.5" />{t}</a>
        ))}
        {cliente.emails?.map((e) => (
          <a key={e} href={`mailto:${e}`} className="inline-flex items-center gap-1 hover:text-[#4DD4E8]"><Mail className="w-3.5 h-3.5" />{e}</a>
        ))}
        {(cliente.morada || cliente.localidade) && (
          <span className="inline-flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />{[cliente.morada, cliente.localidade].filter(Boolean).join(', ')}</span>
        )}
        {cliente.comercial && <span className="inline-flex items-center gap-1" data-testid="c360-client-comercial"><UserCheck className="w-3.5 h-3.5" />{cliente.comercial}</span>}
      </div>
      <div className="flex flex-wrap gap-2" data-testid="c360-services">
        <span className="text-xs text-white/70 self-center">Tem hoje:</span>
        {resumo.servicos.length === 0 && <span className="text-xs text-white/70">nenhum serviço ativo</span>}
        {resumo.servicos.map((s) => (
          <span key={s} className={`text-xs font-semibold px-2.5 py-0.5 rounded-full border ${GRUPO[s]?.cls}`}>{GRUPO[s]?.label || s}</span>
        ))}
      </div>
    </div>
    <div className="flex gap-2 shrink-0">
      <Stat label="Contratos" value={resumo.contratos} testId="c360-stat-contratos" />
      <Stat label="Ativos" value={resumo.ativos} testId="c360-stat-ativos" />
      <Stat label="Leads" value={resumo.leads} testId="c360-stat-leads" />
    </div>
  </div>
);
